export default __webpack_public_path__ + "static/media/Logo Giovanni Sechi copy.bab82718.jpg";